import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const ProctoringDataApi = createApi({
  reducerPath: "ProctoringDataApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    postProctoringDataByUserId: builder.mutation({
      query: ({ ongoingId, userId }: any) => {
        return {
          url: `/proctoring/analytics/${ongoingId}`,
          method: "POST",
          body: {
            userId: userId
          }
        };
      },
      extraOptions: { service: "Assessment" }
    }),
    getProctoringDataByUserId: builder.query({
      query: ({ ongoingId, key, pageSize, pageNumber }: any) => {
        return {
          url: `/proctoring/analytics/${ongoingId}?key=${key}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Assessment" }
    })
  })
});

export const {
  usePostProctoringDataByUserIdMutation,
  useGetProctoringDataByUserIdQuery,
  useLazyGetProctoringDataByUserIdQuery
} = ProctoringDataApi;
